import { Injectable } from "@angular/core";
import { ShowsApi, AnnouncementsApi } from "api";
import { Cache, PagedArray } from "common";
import { Show, Announcement } from "models";

@Injectable()
export class AnnouncementsService {
    constructor(
        private announcementsApi : AnnouncementsApi
    ) {

    }

    cache = Cache.shared<Announcement>('announcements', 1000 * 60 * 15, 100);
    showListCache = Cache.shared<PagedArray<Announcement>>('announcements-list', 1000 * 60 * 15, 50);

    async all(offset?, limit?) {
        return await this.showListCache.fetch(`page-${offset}-${limit}`, async () => await this.announcementsApi.all(offset, limit).toPromise() as PagedArray<Announcement>);
    }

    async get(id : string) {
        return await this.cache.fetch(id, async () => await this.announcementsApi.get(id).toPromise() as Announcement);
    }
}